const KEY = 'categoriesState';

export default {
  getAll: () => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || null);
    } catch (error) {
      return null;
    }
  },
  get: (genreId) => {
    let states;
    try {
      states = JSON.parse(localStorage.getItem(KEY) || '{}');
    } catch (error) {
      states = {};
    }
    return states[genreId] || false;
  },
  set: (genreId, state) => {
    try {
      const states = JSON.parse(localStorage.getItem(KEY) || '{}');
      states[genreId] = state;
      localStorage.setItem(KEY, JSON.stringify(states));
    } catch (error) {}
  },
}
